import { AUTH_TOKEN } from 'app/constants';
import { PaginationResponseType, SuccessResponseType } from 'app/console-api';

export interface AppCategory {
  id: number;
  appID: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface AppCategoryRequest {
  name: string;
}

export const createAppCategory = async (
  appID: string,
  category: AppCategoryRequest
): Promise<SuccessResponseType<AppCategory>> => {
  let token = localStorage.getItem(AUTH_TOKEN) || '';

  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/categories`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(category)
    }
  );
  if (!response.ok) {
    return Promise.reject(await response.json());
  }
  return await response.json();
};

export const getAppCategories = async (
  appID: string
): Promise<PaginationResponseType<AppCategory>> => {
  let token = localStorage.getItem(AUTH_TOKEN) || '';
  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/categories`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  if (!response.ok) {
    return Promise.reject(await response.json());
  }
  return await response.json();
};

export const updateAppCategory = async (
  appID: string,
  catID: number,
  category: AppCategoryRequest
): Promise<AppCategory> => {
  let token = localStorage.getItem(AUTH_TOKEN) || '';
  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/categories/${catID}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(category)
    }
  );
  if (!response.ok) {
    return Promise.reject(await response.json());
  }
  return await response.json();
};
